/**
 * Hier wird das Submenu eingebunden und die einzelenen Module dazu verlinkt Bei Bedarf kann auch ein Modul ausgetauscht werden oder lokal neu entwickelt werden.
 */

import React from 'react'
import { Grid } from '@mui/material'

import UserDashboardNetworkContent from './subScreens/UserDashboardNetworkContent'

import UserDashboardPosting from './subScreens/UserDashboardPosting'
import UserDashboardCalendar from './subScreens/UserDashboardCalendar'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useRouteMatch } from 'react-router'

const UserDashboard: React.FC = () => {
  const { path } = useRouteMatch()

  return (
    <Grid container columnSpacing={2} sx={{ px: 2, pb: 12 }}>
      <Grid
        xs={12}
        item
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <Switch>
            <Redirect exact from={`${path}`} to={`${path}/networkContent`} />
            <Route path={`${path}/networkContent`}>
              <UserDashboardNetworkContent />
            </Route>
            <Route exact path={`${path}/posting`}>
              <UserDashboardPosting />
            </Route>
            <Route path={`${path}/posting/:deferredPostId`}>
              <UserDashboardPosting />
            </Route>
            <Route path={`${path}/calendar`}>
              <UserDashboardCalendar />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default UserDashboard
